import React, { useCallback, useEffect, useRef, useState } from 'react';
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery-bundle.css';
// import plugins
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';

const Gallery: React.FC = () => {
   const lightGalleryRefs = useRef<any[]>([]);
   const [galleryWrappers, setGalleryWrappers] = useState<number>(0);
   const [galleryImageDataWrappers, setImageDataWrappers] = useState<number>(0);
   const [galleryElements, setGalleryElements] = useState<Element[]>([]);

   useEffect(() => {
      // Get all gallery-wrapper elements and gallery-all-images-data elements
      const wrappers = document.querySelectorAll('.gallery-wrapper');
      const imageDataWrappers = document.querySelectorAll('.gallery-all-images-data');
      setGalleryWrappers(wrappers.length);
      setImageDataWrappers(imageDataWrappers.length);
      setGalleryElements(Array.from(imageDataWrappers));

      // Initialize refs array based on number of wrappers
      lightGalleryRefs.current = Array(wrappers.length).fill(null);

      if (wrappers.length === imageDataWrappers.length && wrappers.length > 0)
         document.querySelectorAll(".gallery-wrapper").forEach((gallery: any, id: any) => {
            gallery.querySelectorAll(".gallery-items").forEach((el: any, index: any) => {
               el.addEventListener("click", () => {
                  lightGalleryRefs.current[id]?.openGallery(index);
               });
            });
         });
   }, []);

   const onInit = useCallback((detail: any, galleryIndex: number) => {
      if (detail) {
         lightGalleryRefs.current[galleryIndex] = detail.instance;
      }
   }, []);

   // Return null if no gallery wrappers found
   if (galleryWrappers === 0 || galleryImageDataWrappers === 0 || galleryWrappers !== galleryImageDataWrappers) {
      return null;
   }

   return (
      <>
         {galleryElements.map((wrapper, galleryIndex) => {
            const images = Array.from(wrapper.querySelectorAll('img'));

            const dynamicGalleryItems = images.map((img, index) => ({
               src: img?.getAttribute('src'),
               thumb: img?.getAttribute('thumb') || img?.getAttribute('src'),
               subHtml: img?.getAttribute('subHtml') || ''
            }));

            return (
               <LightGallery
                  key={`lightgallery-${galleryIndex}`}
                  onInit={(detail) => onInit(detail, galleryIndex)}
                  dynamic={true}
                  zoom={false}
                  download={false}
                  plugins={[lgZoom, lgVideo, lgThumbnail]}
                  dynamicEl={dynamicGalleryItems}
                  addClass={`gallery-lightbox-${galleryIndex}`}
               >
               </LightGallery>
            );
         })}
      </>
   );
};

export default Gallery;